import type { SelectorOption } from '../../../Components/common';

export const CREATIVITY_OPTIONS: SelectorOption[] = [
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
    { label: 'High', value: 'high' },
];

export const STYLE_OPTIONS: SelectorOption[] = [
    { label: 'Sleek and Modern', value: 'sleek_and_modern' },
    { label: 'Bold & Colorful', value: 'bold_and_colorful' },
    { label: 'Elegant', value: 'elegant' },
    { label: 'Conservative & Traditional', value: 'conservative_and_traditional' },
    { label: 'Compact', value: 'compact' },
    { label: 'Geometric', value: 'geometric' },
    { label: 'Letter Mark', value: 'letter_mark' },
    { label: 'Monochromatic', value: 'monochromatic' },
    { label: 'Neo Memphis', value: 'neo_memphis' },
    { label: 'Surrealist', value: 'surrealist' },
    { label: 'Maximalist', value: 'maximalist' },
    { label: 'Pop Art', value: 'pop_art' },
    { label: 'Handwritten', value: 'handwritten' },
    { label: 'Doodle', value: 'doodle' },
    { label: 'Cultural', value: 'cultural' },
    { label: 'Organic', value: 'organic' },
    { label: 'Playful', value: 'playful' },
    { label: 'Watercolor', value: 'watercolor' },
    { label: 'Illustrative', value: 'illustrative' },
    { label: 'Retro', value: 'retro' },
    { label: 'Vintage', value: 'vintage' },
    { label: 'Zen', value: 'zen' },
    { label: 'Typographic', value: 'typographic' },
    { label: 'To Sleek Typography', value: 'to_sleek_typography' },
    { label: 'To Chaotic Typography', value: 'to_chaotic_typography' },
    { label: 'To Retro', value: 'to_retro' },
    { label: 'To Minimal', value: 'to_minimal' },
    { label: 'To Script', value: 'to_script' },
    { label: 'To Cute Bubble', value: 'to_cute_bubble' },
    { label: 'To Grunge', value: 'to_grunge' },
    { label: 'To Modern', value: 'to_modern' },
    { label: 'To Festive Script', value: 'to_festive_script' },
    { label: 'To Bold Minimal', value: 'to_bold_minimal' },
    { label: 'To Curved Retro', value: 'to_curved_retro' },
    { label: 'To Layered Blocks', value: 'to_layered_blocks' },
    { label: 'To Art Deco', value: 'to_art_deco' },
    { label: 'To 8 Bit', value: 'to_8-bit' },
    { label: 'To Hand Painted', value: 'to_hand-painted' },
    { label: 'To Fashionable Serif', value: 'to_fashionable_serif' },
    { label: 'To Tech Monospace', value: 'to_tech_monospace' },
    { label: 'To Layered Typography', value: 'to_layered_typography' },
    { label: 'To Vibrant Gradient', value: 'to_vibrant_gradient' },
    { label: 'To Glow', value: 'to_glow' },
    { label: 'To Neon', value: 'to_neon' },
];

export const PRIORITY_OPTIONS: SelectorOption[] = [
    { label: 'Cost', value: 'cost' },
    { label: 'Balanced', value: 'balanced' },
    { label: 'Quality', value: 'quality' },
    { label: 'Experimental', value: 'experimental' },
];

export enum GENERATE_LOGO_CULTURE {
    EnUs = 'en-us',
    FrFr = 'fr-fr',
    FrBe = 'fr-be',
    DeDe = 'de-de',
    DeAt = 'de-at',
    EsEs = 'es-es',
    EsUs = 'es-us',
    EnCa = 'en-ca',
    EnIn = 'en-in',
    EnSg = 'en-sg',
    EnAu = 'en-au',
    EnNz = 'en-nz',
    EnGb = 'en-gb',
    EnIe = 'en-ie',
    ItIt = 'it-it',
    ItCh = 'it-ch',
    NlNl = 'nl-nl',
    NlBe = 'nl-be',
}

export const CULTURE_VALUE_OPTIONS: SelectorOption[] = Object.values(GENERATE_LOGO_CULTURE).map((culture) => ({
    label: culture,
    value: culture,
}));
